import { ALARM_TABS } from '../../components/panels/AlarmPanel/utils';

export const getAlarmsLoading = (state) => state.alarms.isLoading;

export const getAlarmsTotalByTab = (state, tab) => {
  switch (tab) {
    case ALARM_TABS.NEW: {
      return state.alarms.newAlarmsTotal;
    }
    case ALARM_TABS.ACKNOWLEDGED: {
      return state.alarms.acknowledgedAlarmsTotal;
    }
    case ALARM_TABS.RESOLVED: {
      return state.alarms.resolvedAlarmsTotal;
    }
    default: {
      return 0;
    }
  }
};

export const getAlarmsByTab = (state, tab) => {
  switch (tab) {
    case ALARM_TABS.NEW: {
      return state.alarms.newAlarms;
    }
    case ALARM_TABS.ACKNOWLEDGED: {
      return state.alarms.acknowledgedAlarms;
    }
    case ALARM_TABS.RESOLVED: {
      return state.alarms.resolvedAlarms;
    }
    default: {
      return [];
    }
  }
};

export const getAlarmById = (state, alarmId) => {
  const allAlarms = [
    ...state.alarms.newAlarms,
    ...state.alarms.acknowledgedAlarms,
    ...state.alarms.resolvedAlarms,
  ];
  return allAlarms.find((alarm) => alarm.id === alarmId);
};

export const getSourceEventsByAlarmId = (state, alarmId) =>
  state.alarms.sourceEventsByAlarmId[alarmId];

export const getSourceEventsTotal = (state, alarmId) =>
  state.alarms.sourceEventsByAlarmId[alarmId]?.total ?? 0;

export const getSourceEventsLoading = (state, alarmId) =>
  state.alarms.sourceEventsByAlarmId[alarmId]?.loading ?? false;

export const getLogbookByAlarmId = (state, alarmId) => state.alarms.logbookByAlarmId[alarmId];

export const getAlarmsLogbookTotal = (state, alarmId) =>
  state.alarms.logbookByAlarmId[alarmId]?.total ?? 0;

export const getLogbookLoading = (state, alarmId) =>
  state.alarms.logbookByAlarmId[alarmId]?.loading ?? false;

export const getNotifiedAlarmIds = (state) => state.alarms.notifiedAlarmIds;
